import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=1872a376"
import script from "./FormGenerator.vue?vue&type=script&lang=ts"
export * from "./FormGenerator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports